module.exports = __webpack_public_path__ + "static/media/step2.9206c428.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/tbank/step2.jpg
// module id = 712
// module chunks = 0